import React, { Suspense, lazy } from "react";

const AvailableMerch = lazy(() => import("../components/AvailableMerch.js"));

const PublicMerch = () => {
  return (
    <div className="relative z-20 flex flex-col  ">
      <Suspense fallback={<div>Loading...</div>}>
        <AvailableMerch />
      </Suspense>
    </div>
  );
};

export default PublicMerch;
